import React, { useState } from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  consumePassCheckoutPendingError,
  PassCheckoutErrorCode,
} from '../../utils/passCheckoutErrors';

/**
 * One-shot alert for pass checkout failures that happened during post-login resume.
 * Mount once per listing page (not inside each PassOfferList).
 */
const PassCheckoutResumeErrorAlert: React.FC = () => {
  const { t } = useTranslation();
  const [code, setCode] = useState<PassCheckoutErrorCode | null>(() =>
    consumePassCheckoutPendingError(),
  );

  if (!code) return null;

  const message =
    code === 'connectNotReady'
      ? t(
          'passes.checkoutConnectNotReady',
          'This pass is temporarily unavailable for online purchase. The organization has not finished setting up checkout.',
        )
      : t('passes.checkoutError', 'Failed to start checkout. Please try again.');

  return (
    <Alert
      severity={code === 'connectNotReady' ? 'warning' : 'error'}
      onClose={() => setCode(null)}
      sx={{ mb: 2 }}
    >
      {message}
    </Alert>
  );
};

export default PassCheckoutResumeErrorAlert;
